// simple djb2 string hash -> positive integer
export function djb2Hash(str) {
  const s = String(str);
  let h = 5381;
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) + h) + s.charCodeAt(i); // h * 33 + c
    // keep in 32-bit
    h = h >>> 0;
  }
  return h;
}

// convert to hex (short)
export function djb2Hex(str, len = 8) {
  const n = djb2Hash(str);
  return n.toString(16).padStart(8, '0').slice(-len);
}
